<template>
  <div class="container">
    <div class="form-wrapper" id="mainForm">
      <accept-popup :disableLeft="pickedEmployee.NumberVotes > 4" :name="pickedEmployee.Description" :total="totalScore" :active="popupActive" @repeatVote="repeatVote" @newVote="newVote" />
      <div class="form-head d-flex align-center w100">
        <div class="form-title text-medium">Номінуй найкращих</div>
        <div class="form-counter d-flex ml-a">
          <img src="./../assets/images/clock.png" class="form-counter__icon position-relative" alt="" />до закінчення голосування:
          <div class="form-counter__day d-flex">
            <b>{{ time }}</b> {{ days }}
          </div>
        </div>
      </div>
      <div class="form-body">
        <div class="search-form position-relative w100" v-bind:class="{active: searchText}">
          <input id="search" type="text" class="search-form__input w100" v-model="searchText" placeholder="Почніть вводити прізвище" autocomplete="off" />
          <label for="search" class="search-form__label position-absolute">
            <span class="position-absolute d-inline-b search-form__label-text">Пошук номінанта</span>
          </label>
          <button v-if="searchText" v-on:click="searchText = ''" class="search-form__clean position-absolute cursor-pointer">
            <svg class="search-form__clean-icon" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.9993 0.666672C6.62602 0.666672 0.666016 6.62667 0.666016 14C0.666016 21.3733 6.62602 27.3333 13.9993 27.3333C21.3727 27.3333 27.3327 21.3733 27.3327 14C27.3327 6.62667 21.3727 0.666672 13.9993 0.666672ZM19.7327 19.7333C19.2127 20.2533 18.3727 20.2533 17.8527 19.7333L13.9993 15.88L10.146 19.7333C9.62602 20.2533 8.78602 20.2533 8.26602 19.7333C7.74602 19.2133 7.74602 18.3733 8.26602 17.8533L12.1193 14L8.26602 10.1467C7.74602 9.62667 7.74602 8.78667 8.26602 8.26667C8.78602 7.74667 9.62602 7.74667 10.146 8.26667L13.9993 12.12L17.8527 8.26667C18.3727 7.74667 19.2127 7.74667 19.7327 8.26667C20.2527 8.78667 20.2527 9.62667 19.7327 10.1467L15.8793 14L19.7327 17.8533C20.2393 18.36 20.2393 19.2133 19.7327 19.7333Z"
                fill="#202124"
                fill-opacity="0.54"
              />
            </svg>
          </button>
          <div class="search-form__list-layout position-absolute w100" v-if="items.length">
            <div v-if="searchText" class="search-form__list p-2">
              <!-- <div class="search-form__list-item search-form__list-item_user cursor-pointer p-2">Я (Коваленко Яна Олегівна)</div> -->
              <!-- <div class="search-form__list-label pt-1 pl-2">Раніше номіновані</div> -->
              <div v-for="(item, i) in items" :key="i" class="search-form__list-item cursor-pointer p-2" @click="pickEmployee(item)">
                <div class="search-form__list-item-title">{{ item.Description }}</div>
                <div class="search-form__list-item-description">{{ item.PostsDescription }}</div>
                <div class="search-form__list-item-description-sub">{{ item.StructureDescription }}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="emptyPickedEmployee">
          <!--- start condition of occurrence message --->
          <!--- if ---->
          <div class="form-message pt-3" v-if="pickedEmployee.NumberVotes < 5">Можливо номінувати: {{ 5 - pickedEmployee.NumberVotes }} разів</div>
          <!--- else ---->
          <div class="form-message pt-3" v-else>Ви вже номінували цього колегу максимально 5 разів. Оберіть когось іншого :)</div>
          <!--- end condition of occurrence message --->
        </div>

        <div class="form-text pb-2">Оціни, на скільки номінант відповідає характеристикам нижче</div>
        <div class="d-flex rating-layout">
          <div>
            <div class="rating-layout__title pb-1 text-medium">Профі</div>
            <div class="rating-layout__description">Професіонал своєї справи</div>
          </div>
          <div class="d-flex flex-column ml-a rating-layout__item">
            <div class="rating d-flex align-center">
              <input id="pro5" class="rating__input" type="radio" name="pro" :value="5" v-model="rating[0]" />
              <label for="pro5" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro4" class="rating__input" type="radio" name="pro" :value="4" v-model="rating[0]" />
              <label for="pro4" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro3" class="rating__input" type="radio" name="pro" :value="3" v-model="rating[0]" />
              <label for="pro3" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro2" class="rating__input" type="radio" name="pro" :value="2" v-model="rating[0]" />
              <label for="pro2" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro1" class="rating__input" type="radio" name="pro" :value="1" v-model="rating[0]" />
              <label for="pro1" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
            </div>
            <div class="d-flex">
              <div class="rating__description">норм 👌</div>
              <div class="rating__description ml-a">вау 🤘</div>
            </div>
          </div>
        </div>
        <div class="d-flex rating-layout">
          <div>
            <div class="rating-layout__title pb-1 text-medium">Суперсервіс</div>
            <div class="rating-layout__description">
              Надзвичайно клієнтоорієнований <br />
              і з клієнтами, і з колегами
            </div>
          </div>
          <div class="d-flex flex-column ml-a rating-layout__item">
            <div class="rating d-flex align-center">
              <input id="pro55" class="rating__input" type="radio" name="super" :value="5" v-model="rating[1]" />
              <label for="pro55" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro44" class="rating__input" type="radio" name="super" :value="4" v-model="rating[1]" />
              <label for="pro44" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro33" class="rating__input" type="radio" name="super" :value="3" v-model="rating[1]" />
              <label for="pro33" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro22" class="rating__input" type="radio" name="super" :value="2" v-model="rating[1]" />
              <label for="pro22" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro11" class="rating__input" type="radio" name="super" :value="1" v-model="rating[1]" />
              <label for="pro11" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
            </div>
            <div class="d-flex">
              <div class="rating__description">норм 👌</div>
              <div class="rating__description ml-a">вау 🤘</div>
            </div>
          </div>
        </div>
        <div class="d-flex rating-layout">
          <div>
            <div class="rating-layout__title pb-1 text-medium">Командний гравець</div>
            <div class="rating-layout__description">
              З ним класно працювати разом <br />
              та досягати спільних результатів
            </div>
          </div>
          <div class="d-flex flex-column ml-a rating-layout__item">
            <div class="rating d-flex align-center">
              <input id="pro555" class="rating__input" type="radio" name="command" :value="5" v-model="rating[2]" />
              <label for="pro555" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro444" class="rating__input" type="radio" name="command" :value="4" v-model="rating[2]" />
              <label for="pro444" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro333" class="rating__input" type="radio" name="command" :value="3" v-model="rating[2]" />
              <label for="pro333" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro222" class="rating__input" type="radio" name="command" :value="2" v-model="rating[2]" />
              <label for="pro222" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
              <input id="pro111" class="rating__input" type="radio" name="command" :value="1" v-model="rating[2]" />
              <label for="pro111" class="rating__label cursor-pointer d-flex align-center justify-center">
                <svg class="rating__icon" width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    class="rating__icon-fill"
                    d="M13.023 20.0993L19.1126 23.7824C20.2278 24.4574 21.5924 23.4595 21.299 22.1976L19.6849 15.2716L25.0701 10.6054C26.0532 9.75433 25.525 8.14022 24.2337 8.03751L17.1463 7.43589L14.373 0.891426C13.8741 -0.297142 12.1719 -0.297142 11.673 0.891426L8.8997 7.42121L1.81231 8.02284C0.521027 8.12555 -0.00722554 9.73966 0.975911 10.5907L6.36115 15.257L4.74705 22.1829C4.45357 23.4449 5.81822 24.4427 6.93342 23.7677L13.023 20.0993Z"
                    fill="rgba(32, 33, 36, 0.12)"
                  />
                </svg>
              </label>
            </div>
            <div class="d-flex">
              <div class="rating__description">норм 👌</div>
              <div class="rating__description ml-a">вау 🤘</div>
            </div>
          </div>
        </div>

        <button type="button" class="button button-success form__button text-center" :disabled="!disableButton" @click="confirmVoting">Хочу, щоб колега був на святі</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import AcceptPopup from './AcceptPopup';
import {scroller} from 'vue-scrollto/src/scrollTo';

export default {
  name: 'MainForm',
  components: {
    AcceptPopup,
  },
  data() {
    return {
      searchText: '',
      items: [],
      pickedEmployee: {},
      rating: [0, 0, 0],
      popupActive: false,
      myName: {}
    };
  },
  methods: {
    ...mapActions(['searchEmployee', 'voteEmployee']),
    pickEmployee(e) {
      this.pickedEmployee = {...e};
      this.searchText = `${e.Description}, ${e.PostsDescription}`;
    },
    repeatVote() {
      this.$set(this.rating, 0, 0);
      this.$set(this.rating, 1, 0);
      this.$set(this.rating, 2, 0);
      this.popupActive = false;
      const scrollTo = scroller();
      scrollTo('#mainForm');
    },
    newVote() {
      this.searchText = '';
      this.$set(this.rating, 0, 0);
      this.$set(this.rating, 1, 0);
      this.$set(this.rating, 2, 0);
      this.pickedEmployee = {};
      this.popupActive = false;
      const scrollTo = scroller();
      scrollTo('#mainForm');
    },
    confirmVoting() {
      let params = {
        ...this.pickedEmployee,
        Score_SuperService: this.rating[1],
        Score_TeamPlayer: this.rating[2],
        Score_Professional: this.rating[0],
      };
      params.Phone = params.Phone.replace(/[^0-9]/g, '');
      this.voteEmployee(params).then(() => {
        this.pickedEmployee.NumberVotes++;
        // setTimeout(() => {
        //   console.log('NumberVotes', this.pickedEmployee.NumberVotes);
        // }, 1000);
      });
      this.popupActive = true;
    },
  },
  computed: {
    time() {
      let timeend = new Date(new Date(2021, 6, 17));
      let today = new Date();
      today = Math.floor((timeend - today) / 1000 / 60 / 60 / 24);

      return today;
    },
    days() {
      let text = '';
      if (this.time % 10 == 0 || this.time % 10 > 4) text = 'днів';
      if (this.time % 10 == 1) text = 'день';
      if (this.time % 10 == 2 || this.time % 10 == 3 || this.time % 10 == 4) text = 'дні';
      return text;
    },
    disableButton() {
      const arr = this.rating.every(i => i > 0);
      return arr && this.emptyPickedEmployee && this.pickedEmployee.NumberVotes < 5;
    },
    emptyPickedEmployee() {
      console.log(this.pickedEmployee);
      return !!Object.keys(this.pickedEmployee).length;
    },
    totalScore() {
      return this.rating.reduce((a, e) => a + e);
    },
  },
  watch: {
    searchText() {
      this.searchText = this.filteredName(this.searchText);
      if (this.searchText.length > 2 && !this.searchText.includes(',')) this.searchEmployee(this.searchText).then(res => (this.items = res));
      else this.items = [];
    },
    pickedEmployee: {
      deep: true,
      handler() {
        // console.log(this.pickedEmployee);
      },
    },
  },
  mounted() {
    // this.searchEmployee('').then(res => (this.myName[0] = res))
  },
};
</script>

<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';
.container {
  @media (max-width: 1023px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.form-wrapper {
  background: $white;
  border-radius: sm(24);
  border: 1px solid $border-gray;
  padding: sm(40) sm(24);
  @include _1024 {
    padding: sl(80);
    border-radius: sl(24);
  }
  @include _1920 {
    padding: 80px;
    border-radius: 24px;
  }
}

.form__button {
  padding: sm(14) sm(20);
  font-size: sm(14);
  border-radius: sm(4);
  line-height: math.div(19.6, 14);
  margin-top: sm(24);
  display: block;
  width: 100%;
  @include _1024 {
    padding: sl(14) sl(20);
    font-size: sl(14);
    border-radius: sl(4);
    margin-top: sl(56);
    display: inline-block;
    width: auto;
  }
  @include _1920 {
    padding: 14px 20px;
    font-size: 14px;
    border-radius: 4px;
    line-height: math.div(19.6, 14);
    margin-top: 56px;
  }
}

.form-head {
  padding-bottom: sm(32);
  @media (max-width: 1023px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @include _1024 {
    padding-bottom: sl(48);
  }
  @include _1920 {
    padding-bottom: 48px;
  }
}

.form-body {
  @include _1024 {
    max-width: 880px;
  }
}

.form-title {
  font-size: sm(24);
  padding-bottom: sm(20);
  @include _1024 {
    font-size: sl(32);
    padding-bottom: 0;
  }
  @include _1920 {
    font-size: 32px;
  }
}

.search-form {
  padding-top: sm(8);
  @include _1024 {
    padding-top: sl(8);
  }
  @include _1920 {
    padding-top: 8px;
  }
  &:hover {
    .search-form__label {
      color: $text-default;
    }
  }
  &.active {
    .search-form__label {
      color: $success;
      .search-form__label-text {
        top: 0;
        left: sm(16);
        font-size: sm(12);
        line-height: sm(15.6);
        background-color: $white;
        @include _1024 {
          font-size: sl(14);
          line-height: sl(16.8);
          left: sl(16);
        }
        @include _1920 {
          left: 16px;
          font-size: 14px;
          line-height: 16.8px;
        }
      }
    }
  }

  &__input {
    padding: 0 sm(48) 0 sm(16);
    border-radius: sm(8);
    border: 1px solid $border-gray;
    height: sm(48);
    color: $text-gray;
    font-size: sm(16);
    line-height: 1;
    transition: color 0.2s linear, border 0.2s linear;
    outline: none;
    box-shadow: none;
    background-color: $white;
    @include _1024 {
      height: sl(64);
      border-radius: sl(8);
      padding: 0 sl(50) 0 sl(24);
      font-size: sl(24);
    }
    @include _1920 {
      height: 64px;
      padding: 0 50px 0 24px;
      border-radius: 8px;
      font-size: 24px;
    }
    &::placeholder {
      color: transparent;
    }
    &:hover {
      border-color: $text-default;
    }
    &:focus {
      color: $text-gray;
      &::placeholder {
        color: $border-gray;
      }
    }

    &:focus,
    .active & {
      border: 1px solid $success;
      color: $text-default;
    }

    &:focus + .search-form__label {
      color: $success;

      .search-form__label-text {
        top: 0;
        left: sm(16);
        font-size: sm(12);
        line-height: sm(15.6);
        background-color: $white;
        @include _1024 {
          font-size: sl(14);
          line-height: sl(16.8);
          left: sl(16);
        }
        @include _1920 {
          left: 16px;
          font-size: 14px;
          line-height: 16.8px;
        }
      }
    }
  }

  &__label {
    left: 0;
    top: 0;
    color: $text-gray;

    &-text {
      font-size: sm(16);
      line-height: 1;
      transition: top 0.2s linear, left 0.2s linear, color 0.2s linear;
      white-space: nowrap;
      top: sm(25);
      left: sm(17);
      padding: 0 sm(4);
      @include _1024 {
        font-size: sl(24);
        top: sl(28);
        left: sl(24);
        padding: 0 sl(4);
      }
      @include _1920 {
        font-size: 24px;
        top: 28px;
        left: 24px;
        padding: 0 4px;
      }
    }
  }

  &__clean {
    background: transparent;
    border: none;
    outline: none;
    width: sm(24);
    height: sm(24);
    padding: 0;
    top: sm(21.5);
    right: sm(16);
    flex-shrink: 0;
    @include _1024 {
      width: sl(32);
      height: sl(32);
      padding: 0;
      top: sl(25.5);
      right: sl(12);
    }
    @include _1920 {
      width: 32px;
      height: 32px;
      padding: 0;
      top: 25.5px;
      right: 12px;
    }
    &-icon {
      width: sm(20);
      height: sm(20);
      @include _1024 {
        width: sl(26.67);
        height: sl(26.67);
      }
      @include _1920 {
        width: 26.67px;
        height: 26.67px;
      }
    }
  }

  &__list {
    &-label {
      font-size: sm(12);
      line-height: math.div(17, 12);
      color: $text-gray;
      @media (max-width: 1023px) {
        padding-top: sm(8);
        padding-left: sm(8);
      }
      @include _1024 {
        font-size: sl(14);
      }
      @include _1920 {
        font-size: 14px;
      }
    }
    &-layout {
      left: 0;
      bottom: sm(-4);
      transform: translateY(100%);
      background: $white;
      box-shadow: 0px 3px 5px rgba(32, 33, 36, 0.2);
      border-radius: sm(8);
      max-height: sm(304);
      overflow-x: hidden;
      overflow-y: auto;
      @media (max-width: 1023px) {
        padding: sm(8);
      }
      @include _1024 {
        border-radius: sl(8);
        max-height: sl(432);
        bottom: sl(-8);
      }
      @include _1920 {
        bottom: -8px;
        border-radius: 8px;
        max-height: 432px;
      }
    }

    &-item {
      background: $white;
      border-radius: sm(8);
      transition: background-color 0.2s linear;
      @media (max-width: 1023px) {
        padding: sm(8) sm(8);
      }
      @include _1024 {
        border-radius: sl(8);
      }
      @include _1920 {
        border-radius: 8px;
      }

      &:hover {
        background: rgba(32, 33, 36, 0.04);
      }
      &_user {
        font-size: sm(14);
        @media (max-width: 1023px) {
          padding-top: sm(6);
          padding-bottom: sm(6);
        }
        @include _1024 {
          font-size: sl(14);
        }
        @include _1920 {
          font-size: 14px;
        }
      }

      &-title {
        padding-top: sm(2);
        padding-bottom: sm(2);
        font-size: sm(14);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        @include _1024 {
          padding-top: sl(2);
          padding-bottom: sl(2);
          font-size: sl(16);
        }
        @include _1920 {
          padding-top: 2px;
          padding-bottom: 2px;
          font-size: 16px;
        }
      }

      &-description {
        font-size: sm(12);
        color: $text-gray;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        @include _1024 {
          font-size: sl(14);
        }
        @include _1920 {
          font-size: 14px;
        }

        &-sub {
          font-size: sm(12);
          color: $text-gray;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          @include _1024 {
            font-size: sl(14);
          }
          @include _1920 {
            font-size: 14px;
          }
        }
      }
    }
  }
}

.form-text {
  font-size: sm(16);
  padding-top: sm(56);
  @media (max-width: 1023px) {
    padding-bottom: sm(16);
  }
  @include _1024 {
    font-size: sl(24);
    padding-top: sl(96);
  }
  @include _1920 {
    font-size: 24px;
    padding-top: 96px;
  }
}
.form-message {
  font-size: sm(14);
  color: $text-gray;
  @media (max-width: 1023px) {
    padding-top: sm(16);
  }
  @include _1024 {
    font-size: sl(16);
  }
  @include _1920 {
    font-size: 16px;
  }
}
.form-message + .form-text {
  padding-top: sm(24);
  @include _1024 {
    padding-top: sl(50);
  }
  @include _1920 {
    padding-top: 50px;
  }
}

.form-counter {
  align-items: baseline;
  @media (max-width: 1023px) {
    margin-left: 0;
    font-size: sm(14);
  }

  &__icon {
    width: sm(16);
    height: sm(16);
    margin-right: sm(6);
    object-position: center;
    object-fit: contain;
    top: sm(2);
    @include _1024 {
      width: sl(18);
      height: sl(18);
      margin-right: sl(6);
      top: sl(2);
    }
    @include _1920 {
      width: 18px;
      height: 18px;
      margin-right: 6px;
      top: 2px;
    }
  }

  &__day {
    align-items: baseline;
    padding-left: sm(12);
    @include _1024 {
      padding-left: sl(12);
    }
    @include _1920 {
      padding-left: 12px;
    }
    b {
      font-size: sm(18);
      padding-right: sm(6);
      @include _1024 {
        font-size: sl(24);
        padding-right: sl(6);
      }
      @include _1920 {
        font-size: 24px;
        padding-right: 6px;
      }
    }
  }
}

.rating-layout {
  padding: sm(24) 0;
  @media (max-width: 1023px) {
    flex-direction: column;
  }
  @include _1024 {
    padding: sl(32) 0;
  }
  @include _1920 {
    padding: 32px 0;
  }
  &__item {
    @media (max-width: 1023px) {
      margin-left: 0;
    }
  }

  & + & {
    border-top: 1px solid rgba(32, 33, 36, 0.12);
  }

  &__title {
    font-size: sm(24);
    @media (max-width: 1023px) {
      padding-bottom: sm(4);
    }
    @include _1024 {
      font-size: sl(32);
    }
    @include _1920 {
      font-size: 32px;
    }
  }

  &__description {
    font-size: sm(14);
    color: $text-gray;
    @media (max-width: 1023px) {
      padding-bottom: sm(16);
    }
    @include _1024 {
      font-size: sl(20);
    }
    @include _1920 {
      font-size: 20px;
    }
  }
}

.rating__description {
  padding-top: sm(2);
  color: $text-gray;
  @media (max-width: 1024px) {
    font-size: sm(12);
  }
  @include _1024 {
    padding-top: sl(4);
  }
  @include _1920 {
    padding-top: 4px;
  }
}

.rating {
  flex-direction: row-reverse;
  @media (max-width: 1023px) {
    justify-content: space-between;
  }

  &__input {
    display: none;

    &:checked + .rating__label .rating__icon-fill,
    &:checked + .rating__label + .rating__input + .rating__label .rating__icon-fill,
    &:checked + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label .rating__icon-fill,
    &:checked + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label .rating__icon-fill,
    &:checked + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label .rating__icon-fill {
      fill: #ffd601;
    }
  }

  &__label {
    width: sm(48);
    height: sm(48);
    @include _1024 {
      width: sl(48);
      height: sl(48);
    }
    @include _1920 {
      width: 48px;
      height: 48px;
    }

    &:hover .rating__icon-fill,
    &:hover + .rating__input + .rating__label .rating__icon-fill,
    &:hover + .rating__input + .rating__label + .rating__input + .rating__label .rating__icon-fill,
    &:hover + .rating__input + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label .rating__icon-fill,
    &:hover + .rating__input + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label + .rating__input + .rating__label .rating__icon-fill {
      fill: #ffd601;
    }
  }

  &__icon {
    width: sm(37.67);
    height: sm(36);
    @include _1024 {
      width: sl(37.67);
      height: sl(36);
    }
    @include _1920 {
      width: 37.67px;
      height: 36px;
    }

    &-fill {
      transition: all 0.2s linear;
    }
  }
}
</style>
